import * as CryptoJS from 'crypto-js';

const decrypt = (encryptedBase64, key) => {
    let keyUtf8 = key ? CryptoJS.enc.Utf8.parse(key) : "";
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, keyUtf8, {
        iv: CryptoJS.enc.Utf8.parse("asdasdasdasdas")
    });
    if (decrypted) {
        try {
            const str = decrypted.toString(CryptoJS.enc.Utf8);
            if (str.length > 0) {
                return str;
            } else {
                return "error 1";
            }
        } catch (e) {
            return "error 2";
        }
    }
    return "error 3";
};

export { decrypt }